export enum RealtyRegions {
  Moscow = 1,
  MoscowArea = 4593,
  MoscowAndArea = -1,
  StPetersburg = 2,
  StPetersburgArea = 4588,
  StPetersburgAndArea = -2,
  Rostov = 4959,
  RostovArea = 4606,
}
